function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS ProviderCard INSTEAD.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty, noop } from 'lodash';
import { Icon } from '@unite-us/ui';
import addresses from "../../utils/addresses";
import ContactInformation from "../../contact/ContactInformation";
import HoursOfOperationV2 from "../../hours/HoursOfOperationV2";
import arrays from "../../utils/arrays";
import serviceTypeUtils from "../../utils/serviceTypes";
import ProviderCardAddRemoveButton from "../ProviderCard/components/ProviderCardAddRemoveButton";
import InfoPopover from "../../InfoPopover";
import InfoPanel from "../../InfoPanel/InfoPanel";

/**
 * @visibleName ProviderCardV2 DEPRECATED
*/
var ProviderCardV2 = /*#__PURE__*/function (_Component) {
  function ProviderCardV2(props) {
    var _this;
    _classCallCheck(this, ProviderCardV2);
    _this = _callSuper(this, ProviderCardV2, [props]);
    _this.onAddProvider = _this.onAddProvider.bind(_this);
    _this.onRemoveProvider = _this.onRemoveProvider.bind(_this);
    _this.onDetailClick = _this.onDetailClick.bind(_this);
    _this.generateMoreAddressCountText = _this.generateMoreAddressCountText.bind(_this);
    var provider = props.provider,
      originLatLng = props.originLatLng;
    var calculatedDistances = provider.addresses.map(function (address) {
      return addresses.calculateDistance(address, originLatLng);
    });
    var closestDistanceAddress = addresses.findClosestDistanceAddress(calculatedDistances);
    _this.state = {
      addressLength: provider.addresses.length,
      closestDistanceAddress: closestDistanceAddress,
      originLatLng: originLatLng
    };
    return _this;
  }
  _inherits(ProviderCardV2, _Component);
  return _createClass(ProviderCardV2, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.originLatLng[0] !== this.state.originLatLng[0] || nextProps.originLatLng[1] !== this.state.originLatLng[1]) {
        var provider = nextProps.provider;
        var calculatedDistances = provider.addresses.map(function (address) {
          return addresses.calculateDistance(address, nextProps.originLatLng);
        });
        var closestDistanceAddress = addresses.findClosestDistanceAddress(calculatedDistances);
        this.setState({
          closestDistanceAddress: closestDistanceAddress,
          originLatLng: nextProps.originLatLng
        });
      }
    }
  }, {
    key: "onAddProvider",
    value: function onAddProvider(destinationLatLng) {
      var _this$props = this.props,
        provider = _this$props.provider,
        onAddProvider = _this$props.onAddProvider,
        originLatLng = _this$props.originLatLng;
      var distance = addresses.getDistanceInMiles(originLatLng, destinationLatLng, {
        format: 'float'
      });
      var providerWithDistance = _objectSpread(_objectSpread({}, provider), {}, {
        distance: distance
      });
      onAddProvider(providerWithDistance);
    }
  }, {
    key: "onRemoveProvider",
    value: function onRemoveProvider() {
      var _this$props2 = this.props,
        provider = _this$props2.provider,
        onRemoveProvider = _this$props2.onRemoveProvider;
      onRemoveProvider(provider);
    }
  }, {
    key: "onDetailClick",
    value: function onDetailClick() {
      var _this$props3 = this.props,
        provider = _this$props3.provider,
        onDetailClick = _this$props3.onDetailClick;
      onDetailClick(provider);
    }
  }, {
    key: "generateMoreAddressCountText",
    value: function generateMoreAddressCountText() {
      var text;
      var addressLength = this.state.addressLength;
      if (addressLength > 1) {
        text = "".concat(addressLength - 1, " more");
      }
      return text;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        id = _this$props4.id,
        className = _this$props4.className,
        disableSelection = _this$props4.disableSelection,
        isSelected = _this$props4.isSelected,
        onDetailClick = _this$props4.onDetailClick,
        originLatLng = _this$props4.originLatLng,
        provider = _this$props4.provider,
        selectedServiceType = _this$props4.selectedServiceType,
        unselectable = _this$props4.unselectable,
        serve = _this$props4.serve,
        tooltipText = _this$props4.tooltipText;
      var closestDistanceAddress = this.state.closestDistanceAddress;
      var detailsProps = !onDetailClick ? {} : {
        onClick: this.onDetailClick,
        onKeyPress: this.onDetailClick,
        role: 'button',
        style: {
          cursor: 'pointer'
        },
        tabIndex: 0
      };
      var isInNetworkGroup = provider.licensed;
      var providerServiceTypes = provider.service_types;
      var serviceTypes = serviceTypeUtils.matchingServiceTypes(selectedServiceType, providerServiceTypes);
      var svcTypeBanner = serviceTypeUtils.serviceTypeBanner(serviceTypes);
      var email_addresses = provider.email_addresses,
        hours = provider.hours,
        phone_numbers = provider.phone_numbers,
        website_url = provider.website_url;
      var showContactInfo = !isEmpty(email_addresses) || !isEmpty(phone_numbers) || !isEmpty(website_url);
      var addressCount = this.generateMoreAddressCountText();
      var location = _objectSpread({
        hours: hours
      }, closestDistanceAddress);
      return /*#__PURE__*/React.createElement(InfoPopover, {
        tooltipText: tooltipText,
        id: id,
        hiddenTooltip: !serve || !tooltipText,
        placement: "right",
        boundariesElement: "window",
        className: "ui-provider-card__tooltip"
      }, /*#__PURE__*/React.createElement("div", {
        className: classnames('ui-provider-card ui-provider-card--v2', className),
        id: "anchor-id-".concat(id)
      }, /*#__PURE__*/React.createElement("div", {
        className: classnames('ui-provider-card__info', {
          'ui-provider-card__info-disabled': disableSelection
        })
      }, serve && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
        className: "ui-provider-card__service-area-icon",
        color: "#4467ab38",
        icon: "IconRadar",
        size: 18
      }), /*#__PURE__*/React.createElement("div", {
        className: "mb-half"
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "ui-location__icon mr-quarter",
        color: "".concat(isInNetworkGroup ? '#4571BA' : '#2C405A'),
        icon: "IconRadar",
        size: 18
      }), /*#__PURE__*/React.createElement(InfoPanel, {
        message: "Serves this area"
      }))), /*#__PURE__*/React.createElement("div", _extends({
        className: "ui-provider-card__detail"
      }, detailsProps), !isInNetworkGroup && /*#__PURE__*/React.createElement("div", {
        className: "ui-provider-card__oon"
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "mr-half",
        color: "#2C405A",
        icon: "IconElectronsArrowV2"
      }), /*#__PURE__*/React.createElement("span", null, "Out of Network Organization")), /*#__PURE__*/React.createElement("h4", {
        className: "ui-provider-card__name"
      }, provider.name), !isEmpty(svcTypeBanner) && /*#__PURE__*/React.createElement("p", {
        className: "ui-provider-card__service-type"
      }, svcTypeBanner), showContactInfo && /*#__PURE__*/React.createElement(ContactInformation, {
        addressCount: addressCount,
        addresses: [location],
        email_addresses: email_addresses,
        hideLabels: true,
        hours: hours,
        isInNetworkGroup: isInNetworkGroup,
        originLatLng: originLatLng,
        phone_numbers: [arrays.findPrimaryOrFirst(phone_numbers)],
        showContactInfoHeader: false,
        showLocationHours: false,
        website_url: website_url,
        serve: serve
      }), /*#__PURE__*/React.createElement(HoursOfOperationV2, {
        hours: location.hours || location.hours_of_operation,
        isInNetworkGroup: isInNetworkGroup,
        showAll: false,
        showHoursIcon: true
      }))), !disableSelection && !unselectable && /*#__PURE__*/React.createElement(ProviderCardAddRemoveButton, {
        destinationLatLng: closestDistanceAddress.latLng,
        distance: closestDistanceAddress.distance,
        onAddClick: this.onAddProvider,
        onRemoveClick: this.onRemoveProvider,
        selected: isSelected
      })));
    }
  }]);
}(Component);
ProviderCardV2.propTypes = {
  /** identifier for each card */
  id: PropTypes.string.isRequired,
  /** className */
  className: PropTypes.string,
  /** true for disabled card state, hidden add/remove button */
  disableSelection: PropTypes.bool,
  /** true indicates this provider is selected */
  isSelected: PropTypes.bool,
  /** called on add button click */
  onAddProvider: PropTypes.func,
  /** called on provider card click */
  onDetailClick: PropTypes.func,
  /** called on remove button click */
  onRemoveProvider: PropTypes.func,
  /** center of map to calculate distance */
  originLatLng: PropTypes.array,
  /** called to open link with AGL protocol */
  openLink: PropTypes.func,
  /** object containing provider data */
  provider: PropTypes.shape({
    addresses: PropTypes.array,
    email_addresses: PropTypes.array,
    group_type: PropTypes.string,
    hours: PropTypes.object,
    licensed: PropTypes.bool,
    name: PropTypes.string,
    phone_numbers: PropTypes.array,
    service_types: PropTypes.array,
    website_url: PropTypes.string
  }).isRequired,
  showMore: PropTypes.bool,
  /** service type object or array of service type objects */
  selectedServiceType: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })), PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })]).isRequired,
  /** true to hide add/remove buttons */
  unselectable: PropTypes.bool,
  /** true to hide location field and show map icon with serve this area label */
  serve: PropTypes.bool,
  /** text to show when using the popover as a tooltip */
  tooltipText: PropTypes.string
};
ProviderCardV2.defaultProps = {
  className: '',
  disableSelection: false,
  isSelected: false,
  onAddProvider: noop,
  onDetailClick: noop,
  onRemoveProvider: noop,
  openLink: typeof window !== 'undefined' ? window.open : function () {},
  originLatLng: [],
  showMore: false,
  unselectable: false,
  serve: false,
  tooltipText: undefined
};
export default ProviderCardV2;